module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("A note on the author")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Alan Warner was born in 1964 in Oban. His 1995 debut, "), _c('em', [_vm._v("Morvern Callar")]), _vm._v(", is a contemporary classic. He has won the Somerset Maugham award and the James Tait Black Memorial Prize, was nominated for the Booker Prize and was picked as a Granta Best Young British Novelist. His other novels include "), _c('em', [_vm._v("The Sopranos, These Demented Lands, The Deadman’s Pedal")]), _vm._v(" and "), _c('em', [_vm._v("Kitchenly 434")]), _vm._v(". He teaches creative writing at the University of Aberdeen."), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45dff8ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 60
// module chunks = 0